import { useState } from 'react';
import styled from 'styled-components';
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';

import Text from '../../../shared/Text';
import TextInput from '../../../shared/FormStyles/TextInput.jsx';
import { Button } from '../../../shared/FormStyles/Button';
import { Fetcher } from '../../../lib/helpers';
import { useNotification } from '../../../shared/Notification/useNotification';

const PotentialUserModal = ({ setUser, demoName }) => {
  const { t } = useTranslation(['shared, users']);

  const { showSuccess, showError } = useNotification();
  const [userName, setUserName] = useState('');

  const saveNameValue = e => {
    setUserName(e.target.value);
  };

  const submit = () => {
    if (userName) {
      Fetcher.xmlHttpRequest({
        method: 'POST',
        path: `/potential_user_conversions?potential_user_name=${userName}`,
        success: resp => {
          if (resp.error) {
            showError({ content: t('shared:errorText') });
          } else {
            setUser(resp);
            showSuccess({
              content: t('users:potentialUserModal.submitSuccess'),
            });
            Swal.clickCancel();
          }
        },
      });
    } else {
      showError({ content: t('shared:errorText') });
    }
  };

  return (
    <RegisterUserContainer>
      <Text m="0 0 16px 0" color="black.100" variant="h5">
        {t('users:potentialUserModal.title', { demoName })}
      </Text>
      <TextInput
        onChange={saveNameValue}
        value={userName}
        label={t('users:potentialUserModal.label')}
        placeholder={t('users:potentialUserModal.placeholder')}
      />
      <Submit
        variant="containedBlue"
        disabled={userName.length < 3}
        onClick={() => submit()}
      >
        {t('users:potentialUserModal.submit')}
      </Submit>
    </RegisterUserContainer>
  );
};

const Container = styled.div`
  display: flex;
`;

const RegisterUserContainer = styled(Container)`
  flex-direction: column;
  align-items: flex-start;
`;

const Submit = styled(Button)`
  align-self: flex-end;
  margin: 16px 0 0;
  ${({ error }) => error && 'margin: 24px 0 0'}
`;

export default PotentialUserModal;
